import { LOCALES } from 'i18n/locales';

export const networkCoverageLegendIntl = {
    [LOCALES.ENGLISH]: {
        'networkCoverageLegend.title': 'Selected asset owner\'s network coverage area(s)',
        'networkCoverageLegend.description': 'The pink area(s) shows the selected asset owner\'s network coverage area in NUAR.',
        'networkCoverageLegend.operationalArea.title': 'Your organisation\'s operational area(s)',
        'networkCoverageLegend.operationalArea.description': 'The blue hatched area(s) show your organisation\'s operational area in NUAR.'

    },
    [LOCALES.WELSH]: {
        'networkCoverageLegend.title': 'Ardal(oedd) cwmpas rhwydwaith perchennog yr ased a ddewiswyd',
        'networkCoverageLegend.description': 'Mae’r ardal binc/ardaloedd pinc yn dangos ardal cwmpas rhwydwaith eich perchennog ased yn NUAR.',
        'networkCoverageLegend.operationalArea.title': 'Ardal weithredol/ardaloedd gweithredol eich sefydliad',
        'networkCoverageLegend.operationalArea.description': 'Mae’r ardal las linellog/ardaloedd glas llinellog yn dangos ardal weithredol eich sefydliad yn NUAR.'
    }
};
